export default "<app-main-nav></app-main-nav>\r\n"